'use client'

import { Button } from '@/components/ui/button'
import { useCareAndShareConfigs } from '@/hooks/react-query/care-and-share/use-configs'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { CareAndShareContainer } from './container'

export const CareShareTransparentShare = () => {
  const t = useTranslations()
  const { data: careAndShareData, isLoading } = useCareAndShareConfigs()

  const explicitness = careAndShareData?.explicitness

  if (isLoading) {
    return <CareShareTransparentShareSkeleton />
  }

  if (!explicitness || explicitness.length === 0) {
    return null
  }

  return (
    <CareAndShareContainer className='md:!py-0'>
      <h2 className='mb-4 text-center font-criteria text-lg font-medium uppercase leading-6 text-neutral-900 lg:mb-8 lg:text-4xl lg:leading-13'>
        {t('care_and_share_hardcode.transparent_share.title')}
      </h2>
      <div className='rounded-2xl bg-neutral-100 px-6 py-2 pr-1 lg:mx-auto lg:max-w-[816px]'>
        <ul className='scrollbar max-h-[350px] overflow-y-auto overflow-x-hidden pr-5'>
          {explicitness.map((item, index) => (
            <li key={index} className='border-b border-b-neutral-300 py-2'>
              <p className='text-xs leading-3.5 text-neutral-500/70'>
                {item.date}
              </p>
              <p
                className='break-words text-base leading-6 text-neutral-800'
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </li>
          ))}
        </ul>
      </div>
      <Button
        asChild
        size={'small'}
        variant='primary'
        className='mx-auto mt-6 flex w-fit justify-center'
      >
        <Link href='/minh-bach-quy-care-and-share'>Minh bạch Care & Share</Link>
      </Button>
    </CareAndShareContainer>
  )
}

const CareShareTransparentShareSkeleton = () => {
  const t = useTranslations()

  return (
    <CareAndShareContainer className='md:!py-0'>
      <h2 className='mb-4 text-center font-criteria text-lg font-medium uppercase leading-6 text-neutral-900 lg:mb-8 lg:text-4xl lg:leading-13'>
        {t('care_and_share_hardcode.transparent_share.title')}
      </h2>
      <div className='rounded-2xl bg-neutral-100 px-6 py-2 pr-1 lg:mx-auto lg:max-w-[816px]'>
        <ul className='scrollbar max-h-[350px] overflow-y-auto overflow-x-hidden pr-5'>
          {Array.from({ length: 5 }).map((_, index) => (
            <li key={index} className='border-b border-b-neutral-300 py-2'>
              <div className='h-4 w-1/4 animate-pulse rounded-lg bg-gray-200' />
              <div className='mt-1 h-6 w-full animate-pulse rounded-lg bg-gray-200' />
            </li>
          ))}
        </ul>
      </div>
    </CareAndShareContainer>
  )
}
